import { render, staticRenderFns } from "./AddressDetailsEditModal.vue?vue&type=template&id=84e6facc"
import script from "./AddressDetailsEditModal.vue?vue&type=script&lang=js"
export * from "./AddressDetailsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports